'use strict'

domConfig = require './dom_config'

# contains 'simple' actions that can be tracked and reported to tracking hub
module.exports = class PageTracking

  constructor: ->
    @recordedFirstPage = false

  pageReady: ->
    return if @recordedFirstPage
    return if not Groupon.Performance

    Groupon.Performance.pageReady()
    @_trackExperimentPerformance()

    @recordedFirstPage = true

  _trackExperimentPerformance: ->
    config = domConfig.get()

    return unless config?.experimentVariants?.length or config?.appliedFinchSettings?.length
    return unless BOOMR?.getVar

    t_resp = BOOMR.getVar('t_resp')
    t_page = BOOMR.getVar('t_page')
    t_done = BOOMR.getVar('t_done')

    experimentVariants = config.experimentVariants or []
    appliedFinchSettings = config.appliedFinchSettings or []

    variants = [].concat(experimentVariants, appliedFinchSettings).join(',')

    OptimizeSuite.TrackingHub.add 'pull_experiment_performance', {t_resp, t_page, t_done, variants}
